<template>
  <div class="section__container" style="height:330px;">
  <div class="container">
    <div v-for="(item, index) in documents" :key="index" class="row">
      <div class="col-2">
        <img :src="iconDocument"  alt="" />
      </div>
      <div class="col-3">
        {{ item.attributes.Title }}
      </div>
      <div class="col-5">
        <button @click="download(item.attributes.Document.data[0].attributes.url)" class="download-button" >Ver documento <img width="28" :src="downloadImg" style="margin-left: 15px;" /></button>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import iconDocument from '@/assets/property/Frame.png'
import downloadImg from '@/assets/property/download-02.png'
import { getPropertyDocuments } from "@/services/property";

export default {
  name: 'DocumentsTab',
  data () {
    return {
      iconDocument:iconDocument,
      downloadImg:downloadImg,
      documents:null
    }
  },
  props: {
    property: {
      type: Object,
      required: true
    }
  },
  methods: {
      download (file) {
          window.location.href = file;
      }
  },
  created() {
    getPropertyDocuments(this.property.id).then((response) => { 
        console.log("response Documents", response.data.data)
        this.documents = response.data.data
      })
  }
}
</script>
<style lang="scss">

.download-button img {
  display: inline;
}

.download-button {
  width: 216.41px;
  height:52.21px;
  top: 190.89px;
  left: 569.36px;
  padding: 8px 16px 8px 16px;
  border-radius: 8px;
  gap: 10px;
  background:#0D051A;
  //styleName: CallToAction/CTA-M16;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #CAEEDD;
}

.download-button:hover {
  background: #3a2e85;
}

.section__container {
  display: flex;
  flex-direction: column;
  gap: 44px;
}

.title {
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  color: #351467;
  margin-bottom: 24px;
}

.table__container {
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.title__background {
  margin: 16px 0;
  padding: 14px 16px;
  background-color: #CAEEDD;
  font-weight: 600;
  color: #351467;
}
</style>